module.exports = __webpack_public_path__ + "static/plc-bg-97351eca53073acb1bbd0fd475d03a30.svg";